import React, { Children } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Wrapper } from './elements';

var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children,
      className = _ref.className,
      alignment = _ref.alignment;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    alignment: alignment
  }, Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement(Wrapper, {
      key: index
    }, child);
  }));
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
ModalFooter.propTypes = {
  children: node,
  className: string,
  alignment: string
};
/**
 * Default props
 */

ModalFooter.defaultProps = {
  children: null,
  className: '',
  alignment: 'left'
};
export default styled(ModalFooter).withConfig({
  displayName: "Footer",
  componentId: "b8vs8i-0"
})(["height:6rem;width:100%;display:flex;align-items:center;", ";", ";", ";", ";"], function (_ref2) {
  var alignment = _ref2.alignment;
  return alignment === 'left' && css(["justify-content:flex-start;"]);
}, function (_ref3) {
  var alignment = _ref3.alignment;
  return alignment === 'right' && css(["justify-content:flex-end;"]);
}, function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment === 'center' && css(["justify-content:center;"]);
}, function (_ref5) {
  var alignment = _ref5.alignment;
  return alignment === 'spaced' && css(["justify-content:space-between;"]);
});